module.exports = __webpack_public_path__ + "img/money3.f3d21846.jpg";